import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

// Mutation pour supprimer une TVA
const DELETE_VAT_WITH_UUID = gql`
  mutation DeleteVat($uuid: ID!) {
    deleteVat(uuid: $uuid)
  }
`;

// Hook personnalisé pour supprimer une TVA
export const useDeleteVat = (refetch) => {

    // Mutation pour supprimer une TVA
    const [deleteVat, { loading: deleteLoading, error: deleteError }] = useMutation(DELETE_VAT_WITH_UUID, {
        onCompleted: refetch // Rafraîchir les données après la mutation
    });

    return {
        deleteVat,
        deleteLoading,
        deleteError
    };
};

export default useDeleteVat;
